<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: 'knowledgeClass',
        key: 'id',
        url: {
          get:'/admin/system/type',
          add:'/admin/system/type',
          edit:'/admin/system/type',
        },
      items: [
        { label: "基本信息", desc: "表单的基本信息", type: "header" },
        {
          label: "分类名称",
          name: "name",
          value: "",
          type: "input",
          width:"400px",
          rules: [{ required: true, trigger: "blur" }],
        },
        // { label: '图标', name: 'imgUrl', value: '', type: 'image', desc: '图片尺寸最低750*420像素比例', rules: [{ required: true, trigger: 'blur' }] },
        { label: "备注", name: "remark", value: "", type: "textarea" ,width:"400px"},
      ],
      forms: {
        createBy:$utils.data.get("auth", "userName")
      },
    };
  },
  created() {
  },
  methods: {
  },
};
</script>
